function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { getURLWithQueryString } from '@finect/front-utils/getURLWithQueryString';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReviewsBlock } from '../../../Reviews/ReviewsBlock';
import { setProductRequest } from '../actions';
import { models } from '../../../Reviews/utils/models';
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      setProductRequest: setProductRequest
    }, dispatch)
  };
};
function fetchProduct(isin, product) {
  var id = isin || product;
  return finectAPI({
    version: 'v4',
    path: getURLWithQueryString("products/".concat(id), {}, {
      encode: false
    }),
    method: 'GET',
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return data;
    },
    onError: function onError() {
      return null;
    }
  }).catch(function () {
    return null;
  });
}
var fetchReviews = function fetchReviews(_ref2) {
  var isin = _ref2.isin,
    product = _ref2.product,
    _ref2$limit = _ref2.limit,
    limit = _ref2$limit === void 0 ? 25 : _ref2$limit,
    _ref2$offset = _ref2.offset,
    offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
    _ref2$order = _ref2.order,
    order = _ref2$order === void 0 ? '-score' : _ref2$order;
  var id = isin || product;
  return finectAPI({
    version: 'v4',
    path: "contents/products/".concat(id, "/reviews?limit=").concat(limit, "&offset=").concat(offset, "&orderby=").concat(order),
    method: 'GET',
    onSuccess: function onSuccess(_ref3) {
      var data = _ref3.data,
        paging = _ref3.paging;
      var reviews = models.reviews(data.reviews, data.authors);
      var request = {
        productId: id,
        limit: limit,
        offset: offset,
        orderBy: order
      };
      if (order === '-score') {
        var orderedReviews = reviews.sort(function (a, b) {
          var _a$author, _a$author$organizatio, _b$author, _b$author$organizatio;
          var aHasAdviser = (_a$author = a.author) === null || _a$author === void 0 ? void 0 : (_a$author$organizatio = _a$author.organizations) === null || _a$author$organizatio === void 0 ? void 0 : _a$author$organizatio.some(function (org) {
            return org.roles.includes('adviser');
          });
          var bHasAdviser = (_b$author = b.author) === null || _b$author === void 0 ? void 0 : (_b$author$organizatio = _b$author.organizations) === null || _b$author$organizatio === void 0 ? void 0 : _b$author$organizatio.some(function (org) {
            return org.roles.includes('adviser');
          });
          if (aHasAdviser && !bHasAdviser) return -1;
          if (!aHasAdviser && bHasAdviser) return 1;
          return 0;
        });
        return {
          items: orderedReviews,
          paging: paging,
          request: request,
          fetched: true,
          fetching: false
        };
      }
      return {
        items: reviews,
        paging: paging,
        request: request,
        fetched: true,
        fetching: false
      };
    },
    onError: function onError() {
      return null;
    }
  }).catch(function () {
    return null;
  });
};
var ProductReviews = function (_React$Component) {
  _inherits(ProductReviews, _React$Component);
  var _super = _createSuper(ProductReviews);
  function ProductReviews() {
    var _this;
    _classCallCheck(this, ProductReviews);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      product: null,
      reviews: null,
      paging: {
        limit: null,
        totalItems: null
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleProductRequest", function () {
      _this.props.actions.setProductRequest(_this.state.product);
    });
    return _this;
  }
  _createClass(ProductReviews, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        isin = _this$props.isin,
        product = _this$props.product,
        limit = _this$props.limit,
        order = _this$props.order;
      var promises = isin ? [fetchProduct(isin, product), fetchReviews({
        isin: isin,
        product: product,
        limit: limit,
        offset: 0,
        order: order
      })] : [];
      Promise.all(promises).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          productData = _ref5[0],
          reviewsData = _ref5[1];
        if (productData) _this2.setState({
          product: productData
        });
        if (reviewsData) _this2.setState({
          reviews: reviewsData
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        product = _this$state.product,
        reviews = _this$state.reviews;
      if (product && reviews && reviews.items.length > 0) {
        return React.createElement(ReviewsBlock, {
          me: this.props.user,
          finectApp: this.props.finectApp,
          reviews: reviews,
          asideHidden: false,
          product: _objectSpread(_objectSpread({}, product), product.entity),
          simple: true,
          showMoreButton: true,
          forceMoreButton: this.props.forceMoreButton,
          qty: this.props.limit
        });
      }
      return null;
    }
  }]);
  return ProductReviews;
}(React.Component);
export default connect(mapStateToProps, mapDispatchToProps)(ProductReviews);